module.exports = __webpack_public_path__ + "img/work_from_anywhere1.741e3a45.png";